import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './term-events.module.scss'
import CreateSociogramModal from '../CreateSociogramModal'
import SociogramSurveysList from '@BUP/components/Generics/CollapsePanel/SociogramSurveysList'
import ButtonComponent from '@BUP/components/Generics/Button'
import { EventsContext } from '@BUP/contexts/EventsContext'
import { CurrentSociogramContext } from '@BUP/contexts/CurrentSociogramContext'
import { useSociogramActions, useSociogramState } from '@BUP/hooks/Sociogram/useSociogramContext'
import { CoursesContext } from '@BUP/contexts/CoursesContext'
import AlertComponent from '@BUP/components/Generics/Alert'

const TermEvents = () => {
  const i18n = useTranslation()
  const { sociogramId, sociogramState } = useSociogramState()
  const { setSociogramId, setSociogramState } = useSociogramActions()
  const { dataCurrentSociogram } = useContext(CurrentSociogramContext)
  const { events } = useContext(EventsContext)
  const { courses } = useContext(CoursesContext)

  const arraySociogramsIds = events
    .filter(event => event.createdAt)
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    .map(event => event.activityId)

  useEffect(() => {
    setSociogramId(arraySociogramsIds[sociogramState])
  }, [arraySociogramsIds, setSociogramId, sociogramState])
  const { currentSociogram, remainingSociograms } = dataCurrentSociogram

  if (courses.length === 0) {
    return (
      <div className={styles.modal_wrapper}>
        <div className={styles.alert_wrapper}>
          <AlertComponent message={i18n.t('pages.data.sociogram.activeSociogramEce.noCoursesText')} type='info' />
        </div>
      </div>
    )
  }

  if (!currentSociogram || arraySociogramsIds.length === 0) {
    return (
      <div className={styles.modal_wrapper}>
        <CreateSociogramModal />
      </div>
    )
  }

  const { isDone: isDoneCurrentSociogram } = currentSociogram
  const isFirstSociogramActive = remainingSociograms === 1 && !isDoneCurrentSociogram

  const handleSociogram = index => {
    setSociogramState(index)
    setSociogramId(arraySociogramsIds[index])
  }

  const existSecondSociogram =
    !sociogramId && sociogramState === 1
      ? (
        <div className={styles.modal_wrapper}>
          <CreateSociogramModal disabled={isFirstSociogramActive} />
        </div>
        )
      : (
        <SociogramSurveysList
          arraySociogramsIds={arraySociogramsIds}
          sociogramId={arraySociogramsIds[sociogramState]}
        />
        )

  return (
    <>
      <div
        className={styles.buttons_wrapper}
        data-test='buttons-wrapper-sociogram'
      >
        <ButtonComponent
          buttonText={i18n.t('pages.data.sociogram.activeSociogramEce.firstSociogramButton')}
          shape='rectangle'
          size='medium'
          colorType='tertiary'
          onClick={() => {
            handleSociogram(0)
          }}
          activeTertiary={sociogramState === 0}
        />
        <ButtonComponent
          buttonText={i18n.t('pages.data.sociogram.activeSociogramEce.secondSociogramButton')}
          shape='rectangle'
          size='medium'
          colorType='tertiary'
          disabled={isFirstSociogramActive}
          onClick={() => {
            handleSociogram(1)
          }}
          activeTertiary={sociogramState === 1}
        />
      </div>
      {existSecondSociogram}
    </>
  )
}

export default TermEvents
